import { create } from './create';
import { deleteEndpoint } from './delete';
import { get } from './get';
import { list } from './list';
import { listPreTrainedFields } from './listPreTrainedFields';
import { patch } from './patch';

export { type EngineFieldCreatePayload } from './create';
export { type EngineFieldListQuery } from './list';
export { type EngineFieldPatchPayload } from './patch';
export { type ListPreTrainedFieldsQuery } from './listPreTrainedFields';

export const engineFields = {
  get,
  list,
  create,
  patch,
  delete: deleteEndpoint,
  listPreTrainedFields,
};
